import {
  Button,
  Icon,
  IconButton,
  ResponsiveValue,
  useBoolean,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useCallback, useContext, useEffect } from "react";
import { BiCurrentLocation } from "react-icons/bi";
import { MapContext } from "../context/map.context";
import ReactGA from "react-ga4";

type Props = {
  children?: string;
  variant?: ResponsiveValue<
    "link" | "outline" | (string & {}) | "solid" | "ghost" | "unstyled"
  >;
};

const LocationButton = ({ children, variant }: Props) => {
  const { watchLocation, personalLocation, flyTo, map } =
    useContext(MapContext);
  const [loading, setLoading] = useBoolean();
  const background = useColorModeValue("gray.200", "gray.900");

  useEffect(() => {
    if (loading) {
      map.on("moveend", setLoading.off);
      return () => map.off("move", setLoading.off);
    }
  }, [setLoading, loading, map]);

  useEffect(() => {
    if (loading && personalLocation) {
      flyTo({
        center: {
          lng: personalLocation.coords.longitude,
          lat: personalLocation.coords.latitude,
        },
        zoom: 16.5,
      });
    }
  }, [loading, personalLocation, flyTo]);

  return children ? (
    <Button
      variant={variant}
      bg={variant === undefined ? background : undefined}
      _hover={{ filter: "brightness(1.2)" }}
      _active={{ filter: "brightness(1)" }}
      aria-label="Highlight my location"
      leftIcon={<Icon as={BiCurrentLocation} />}
      onClick={() => {
        ReactGA.event({
          category: "user_interaction",
          action: `pressed user location button`,
        });
        watchLocation();
        setLoading.on();
      }}
    >
      {children}
    </Button>
  ) : (
    <IconButton
      variant={variant}
      bg={variant === undefined ? background : undefined}
      _hover={{ filter: "brightness(1.2)" }}
      _active={{ filter: "brightness(1)" }}
      boxShadow={variant === undefined ? "md" : undefined}
      aria-label="Highlight my location"
      icon={<Icon as={BiCurrentLocation} />}
      onClick={() => {
        watchLocation();
        setLoading.on();
      }}
    />
  );
};

export default LocationButton;
